/**
 * @file index.tsx
 *
 * @fileoverview Shows blog posts selected for an organization profile.
 */
import { FormattedMessage } from 'react-intl';
import BlogSearchBlogTeaserCell from '~/jobiqo/components/BlogSearch/components/BlogTeaserCell';
import { BlogPost } from '~/jobiqo/models/blog';
import { OrganizationProfile } from '~/jobiqo/types/types';
import { Grid } from '~/vcl/atoms/06-layout/04-grid';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';

interface OrganizationProfileWithBlogPosts extends OrganizationProfile {
  blogPosts?: BlogPost[];
}

interface OrganizationBlogPostsWidgetProps {
  organization: OrganizationProfileWithBlogPosts;
  columns?: 2 | 3;
}

export const OrganizationBlogPostsWidget = ({
  organization,
  columns = 2,
}: OrganizationBlogPostsWidgetProps) => {
  if (!organization.blogPosts?.length) {
    return null;
  }

  return (
    <div>
      <h2>
        <FormattedMessage
          id="organization_blog_posts"
          defaultMessage="Blog posts"
        />
      </h2>
      <Grid columns={[1, columns]} margin={0}>
        {organization.blogPosts.map((blogPost) => (
          <BlogSearchBlogTeaserCell key={blogPost.id} blogPost={blogPost} />
        ))}
      </Grid>
    </div>
  );
};

export default OrganizationBlogPostsWidget;
